import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import styled from 'styled-components';

const Title = styled.h1`
  font-size: 2em;
`;

class PageTitle extends React.PureComponent {
  render() {
    const {pageTitle: {title, subTitle}} = this.props;
    return (
      <div className="body-head">
        <div className="body-header-blue row">
          <div className="col-sm-12">
            <Title className="page-title">
              {title}
              {subTitle && <span>{subTitle}</span>}
            </Title>
          </div>
        </div>
        <abstraction-alert/>
      </div>
    );
  }
}

PageTitle.defaultProps = {
  pageTitle: {title: 'Unamed Page'}
};

PageTitle.propTypes = {
  pageTitle: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string
  })
};

export default connect(
  state => ({
    pageTitle: state.application.pageTitle
  })
)(PageTitle);



// WEBPACK FOOTER //
// ./src/components/PageTitle.js